import { render, staticRenderFns } from "./MultiAvatar.vue?vue&type=template&id=2222164b&scoped=true&"
import script from "./MultiAvatar.vue?vue&type=script&lang=js&"
export * from "./MultiAvatar.vue?vue&type=script&lang=js&"
import style0 from "./MultiAvatar.vue?vue&type=style&index=0&id=2222164b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222164b",
  null
  
)

export default component.exports